// extracted by mini-css-extract-plugin
export default {"itemBadge":"ItemBadge_itemBadge__AoHX+","small":"ItemBadge_small__H61kD","icon":"ItemBadge_icon__6UDch"};